import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    savingInProgress: false,
    isFilesLoading: false,
    customerFormTabsId: 0,
    findCustomerString: "",
    findedCustomers: [],
    isFindingCustomers: false,
    customers: [],
    customerDocuments: [],
    customer: {
      customer_type_id: null,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    removeCustomersFromState(state, id) {
      let customers = [];
      Object.entries(state.customers).forEach((item) => {
        if (Number(item[1].id) != Number(id)) {
          customers.push(item[1]);
        }
      });
      Vue.set(state, "customers", customers);
    },
  },
  actions: {
    find: async function ({ commit, state, dispatch }) {
      if (state.findCustomerString == "") return;
      if (!state.findCustomerString) return;
      if (
        state.findCustomerString.length < 3 &&
        isNaN(parseInt(state.findCustomerString))
      )
        return;
      updateField(state, { path: "isFindingCustomers", value: true });
      updateField(state, { path: "findedCustomers", value: [] });
      return await axios
        .get(
          `${this._vm.$apiURL}/customers?find_string=${state.findCustomerString}`
        )
        .then((response) => {
          updateField(state, { path: "findedCustomers", value: response.data });
          return true;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFindingCustomers", value: false });
        });
    },
    customerNew({ commit, state, dispatch }, payload) {
      updateField(state, { path: "customer", value: {} });
    },
    update({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });

      return axios
        .put(this._vm.$apiURL + "/customers/" + payload.id, state.customer)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.new;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return axios
        .post(this._vm.$apiURL + "/customers", payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          updateField(state, { path: "customer", value: {} });
          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getOne({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + "/customers/" + payload.id)
        .then((response) => {
          updateField(state, { path: "customer", value: response.data });
          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async getCustomerDocuments({ commit, state, dispatch }, payload){
      updateField(state, { path: "customerDocuments", value: [] });
      updateField(state, { path: "isFilesLoading", value: true });
      return await axios
          .get(this._vm.$apiURL + `/customers/${payload}/documents`)
          .then((response) => {
            if(response.data.status === "success") {
              updateField(state, {path: "customerDocuments", value: response.data.data});
            }
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "isFilesLoading", value: false });
          });
    },
    async removeCustomerDocument({ commit, state, dispatch }, payload) {
      return await this._vm
          .$confirm({
            title: this._vm.i18n.t("common.confirm"),
            text: this._vm.i18n.t("common.confirm_remove"),
            cancelText: this._vm.i18n.t("common.no"),
            acceptText: this._vm.i18n.t("common.yes"),
          })
          .then(async (y) => {
            updateField(state, { path: "isFilesLoading", value: true });
            return await axios
                .delete(this._vm.$apiURL + `/customers/${payload.customer_id}/documents/${payload.document_id}`)
                .then((response) => {
                  if (response.data.status === "success") {
                    dispatch("getCustomerDocuments", payload.customer_id);
                    this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                    return true;
                  }
                  updateField(state, { path: "isFilesLoading", value: false });
                })
                .catch((error) => {
                  dispatch("common/showError", { error: error }, { root: true });
                  updateField(state, { path: "isFilesLoading", value: false });
                }).finally(()=>{
                  updateField(state, { path: "isFilesLoading", value: false });
                })
          })
          .catch((n) => {});
    },
    get({ commit, state, dispatch }) {
      updateField(state, { path: "fetched", value: false });
      axios
        .get(this._vm.$apiURL + "/customers")
        .then((response) => {
          updateField(state, { path: "customers", value: response.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async remove({ commit, state, dispatch }, payload) {
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          updateField(state, { path: "fetched", value: false });
          return await axios
            .delete(this._vm.$apiURL + "/customers/" + payload.id, {
              id: payload.id,
            })
            .then((response) => {
              if (response.data.status === "success") {
                commit("removeCustomersFromState", payload.id);
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                return true;
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            })
            .finally(()=>{
              updateField(state, { path: "fetched", value: true });
            })
        })
        .catch((n) => {});
    },
    async uploadDocuments({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFilesLoading", value: true });
      let formData = new FormData();
      payload.files.forEach((file)=>{
        formData.append("files[]", file);
        let availableTypes = [
          "image/png",
          "image/jpeg",
          "application/pdf",
        ]
        if ( ! availableTypes.includes(file.type)) {
          updateField(state, { path: "isFilesLoading", value: false });
          dispatch(
              "common/showError",
              { error: "Wrong file format" },
              { root: true }
          );
          return;
        }
      })

      return await axios
        .post(
          this._vm.$apiURL +
            `/customers/${payload.customer_id}/documents`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((data) => {
          updateField(state, { path: "isFilesLoading", value: false });
          if (data.data.status === "success") {
            this._vm.$inform(this._vm.i18n.t("common.operation_success")+'!');
          }
          return data;
        })
        .catch((error) => {
          updateField(state, { path: "isFilesLoading", value: false });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
  },
};
